/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "GlobalAssetsImportPageService";
const log: any = LoggerModule.getInstance();

export class GlobalAssetsImportPageService {
  private static instance: GlobalAssetsImportPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): GlobalAssetsImportPageService {
    if (!GlobalAssetsImportPageService.instance) {
      GlobalAssetsImportPageService.instance =
        new GlobalAssetsImportPageService(props);
    }
    return GlobalAssetsImportPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async createGroup(group: any) {
    console.log(`inside create group`, group);
    const agent = getAgent();
    return agent.createGroup(group);
  }
}
